module.exports = __webpack_public_path__ + "static/media/dig-6.bbeaf822.png";